(() => {
  document.querySelectorAll('[data-custom-reviews]').forEach(root => {
    if (root.classList.contains('gtp-custom-reviews--ready')) return;
    const cards = [...root.querySelectorAll('[data-review-card]')].map(card => ({
      card,
      text: card.querySelector('.gtp-custom-review__text'),
      button: card.querySelector('[data-review-expand]')
    })).filter(({text, button}) => text && button);
    root.classList.add('gtp-custom-reviews--ready');
    cards.forEach(({card}) => { if (card.hidden) card.hidden = false; });
    let visible = !('IntersectionObserver' in window);
    let queued = false;
    // Read every card before writing any button visibility. Interleaving those
    // operations forces layout repeatedly across the whole review grid.
    const update = () => {
      queued = false;
      if (!visible || !root.isConnected) return;
      const visibility = cards.map(({card, text}) =>
        !card.classList.contains('is-expanded') && text.scrollHeight <= text.clientHeight + 1
      );
      cards.forEach(({button}, index) => {
        if (button.hidden !== visibility[index]) button.hidden = visibility[index];
      });
    };
    const schedule = () => {
      if (!visible || queued) return;
      queued = true;
      requestAnimationFrame(update);
    };
    root.addEventListener('click', event => {
      const expand = event.target.closest('[data-review-expand]');
      if (!expand) return;
      const card = expand.closest('[data-review-card]');
      const open = card.classList.toggle('is-expanded');
      expand.setAttribute('aria-expanded', String(open));
      expand.textContent = open ? 'Show less' : 'Read full review';
    });
    // Expanding a review changes height, not line wrapping in other cards.
    let lastWidth;
    new ResizeObserver(entries => {
      const width = entries[0].contentRect.width;
      if (width === lastWidth) return;
      lastWidth = width;
      schedule();
    }).observe(root);
    new MutationObserver(records => {
      if (records.some(record => {
        const target = record.target.nodeType === Node.ELEMENT_NODE ? record.target : record.target.parentElement;
        return target?.closest('.gtp-custom-review__text');
      })) schedule();
    }).observe(root, {childList:true, subtree:true, characterData:true});
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        visible = entries.some(entry => entry.isIntersecting);
        if (visible) schedule();
      }, {rootMargin: '500px'});
      observer.observe(root);
    }
    document.fonts.ready.then(schedule);
    schedule();
  });
})();
